import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { MatToolbarModule } from "@angular/material/toolbar";

import { TranslocoModule } from "@jsverse/transloco";
import { LorenRoleFormComponent } from "./loren-role-form/loren-role-form.component";
import { LorenSharedDirectivesModule } from "../../shared/directives/loren-shared-directives.module";

const routes: Routes = [
  {
    path: "",
    component: LorenRoleFormComponent,
  },
];

@NgModule({
  declarations: [LorenRoleFormComponent],
  providers: [],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatListModule,
    MatSlideToggleModule,
    MatSelectModule,
    TranslocoModule,
    LorenSharedDirectivesModule,
  ],
})
export class LorenRoleFormModule {}
